// extracted by mini-css-extract-plugin
export var addButton = "_dk-4";
export var contentBlockImage = "_dk-i";
export var contentBlockWidgetPreview = "_dk-g";
export var fulfillmentCutoffWidgetPreview = "_dk-9";
export var imageBackdrop = "_dk-6";
export var imageIcon = "_dk-8";
export var lowProfileImageContainer = "_dk-b";
export var lowProfileImageIcon = "_dk-f";
export var lowProfileImageIconContainer = "_dk-e";
export var lowProfileImagePlaceholder = "_dk-d";
export var lowProfileProductImage = "_dk-c";
export var lowProfileProductUpsellWidgetPreview = "_dk-a";
export var productCard = "_dk-5";
export var productImage = "_dk-7";
export var productReviewsWidgetPreview = "_dk-h";
export var progressBar = "_dk-1";
export var progressBarFill = "_dk-2";
export var progressBarTrack = "_dk-3";
export var shippingOptionWidgetPreview = "_dk-j";
export var shippingUpsellProgressBar = "_dk-k";
export var thresholdUpsellWidgetPreview = "_dk-0";